import PageWrapper from '@srm/ui/page-wrapper';
import Skeleton from '@srm/ui/skeleton';
import DataTableSkeleton from '@srm/ui/data-table/skeleton';
import './SearchFolder.scss';

const SearchFolderSkeleton = () => (
    <PageWrapper
        className="search-folder"
        title={
            <div aria-hidden>
                <Skeleton height={14} radius={6} width="min(220px, 65%)" />
                <Skeleton height={28} radius={10} width="min(40ch, 100%)" mt={3} />
            </div>
        }
    >
        <div className="search-folder__grid-wrap" role="status" aria-label="Загрузка списка" aria-busy="true">
            <DataTableSkeleton fillHeight />
        </div>
    </PageWrapper>
);

export default SearchFolderSkeleton;
